/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// By giving all of the Nav4-HTMLElements a test-id prefix, we can find them again,
// and even build a path from each leaf to the root. We do this in Storybook to
// simulate link-click-selection, since we are not using a real router in SB.
export function getTestId(suffix: string): string {
	return `NAV4_${suffix}`;
}
